import { Menu, MenuItem } from '@mui/material';

type WorkspaceMenuProps = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onMembers: () => void;
  onEdit: () => void;
  onDelete: () => void;
};

export const WorkspaceMenu = ({
  anchorEl,
  onClose,
  onMembers,
  onEdit,
  onDelete,
}: WorkspaceMenuProps) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    slotProps={{
      paper: {
        sx: {
          borderRadius: '3px',
          boxShadow: '0 1px 4px #cccccc',
          minWidth: 190,
        },
      },
    }}
  >
    <MenuItem onClick={onMembers} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
      Workspace members
    </MenuItem>
    <MenuItem onClick={onEdit} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
      Edit workspace
    </MenuItem>
    <MenuItem onClick={onDelete} sx={{ fontSize: 14, fontWeight: 700, py: 1, px: 1 }}>
      Delete workspace
    </MenuItem>
  </Menu>
);
